import { notification } from 'antd';
import { useEffect, useState } from 'react';

import apiDatalake from '../../../../services/apiDatalake';

const useCardData = ({ filters, clientes }) => {
  const [cardData, setCardData] = useState(null);
  const [loadingCardData, setLoadingCardData] = useState(false);

  useEffect(() => {
    const getCardData = async () => {
      if (!clientes) {
        return;
      }

      try {
        setLoadingCardData(true);
        if (filters?.periodo !== null) {
          const { data } = await apiDatalake.post(
            'buscar-cards-consolidados-shipper',
            {
              cpf_cnpj_cliente: clientes,
              ...(filters.periodo[0] && {
                data_inicial: filters.periodo[0].toDate(),
              }),
              ...(filters.periodo[1] && {
                data_final: filters.periodo[1].toDate(),
              }),
              ...(filters.produto &&
                filters.produto?.value !== 'Todos' && {
                  produto: filters.produto.value,
                }),
              ...(filters.cidade &&
                filters.cidade?.value !== 'Todas' && {
                  cidade: filters.cidade.value,
                }),
              ...(filters.estado &&
                filters.estado?.value !== 'Todos' && {
                  estado: filters.estado.value,
                }),
            }
          );

          if (data) {
            setCardData({
              volumeTotal: data.volume_total,
              quantidadeViagens: data.quantidade_viagens,
              numDemandas: data.demanda,
            });
          }
        }
      } catch {
        notification.error({
          message: 'Não foi possível obter os dados dos cards',
          description: 'Tente novamente ou entre em contato com o suporte',
        });
      }
      setLoadingCardData(false);
    };
    getCardData();
  }, [
    filters.periodo,
    filters.produto,
    filters.cidade,
    filters.estado,
    clientes,
  ]);

  return {
    cardData,
    loadingCardData,
  };
};

export default useCardData;
